export const tr = {
    'edit-smart-centers': 'Akıllı merkezleri değiştir',
    'no-formats-message': 'Bu reklamda akıllı merkezler düzenlenemez; farklı bir görsel kullanmayı deneyin',
    'no-image-message': 'Görsel içermeyen reklamlarda akıllı merkezler düzenlenemez'
};
